import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { a as addDots } from './dots-By_KY3Cn.js';
import { a as addAccessibility, A as Accessibility } from './accessibility-_zCLcLLO.js';

class UspsSection extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;

  connectedCallback() {
    const viewport = this.querySelector('[data-usps-viewport]');
    if (!viewport) return;

    this.#embla = EmblaCarousel(
      viewport,
      {
        align: 'start',
        containScroll: 'trim',
        direction: document.dir || 'ltr',
        breakpoints: {
          '(min-width: 64rem)': { active: false },
        },
      },
      [Accessibility()]
    );

    addDots(this.#embla);
    addAccessibility(this.#embla);
  }

  disconnectedCallback() {
    this.#embla?.destroy();
    this.#embla = undefined;
  }
}

customElements.define('usps-section', UspsSection);
